import { updateEventResponse } from '../utils/eventsCounter';
import fetch from './util/fetchtimeout';

const post = async (config, data) => {
  if (!config || !data) return;
  try {
    const { endpoint, timeout = 15000 } = config;

    // const headers = {};

    //if (config.batch_size) {
    // headers['batch-size'] = config.batch_size;
    //}

    const res = await fetch(
      endpoint,
      {
        method: 'POST',
        body: JSON.stringify(data),
        //headers,
      },
      timeout
    );

    if (res.status >= 200 && res.status < 300) {
      updateEventResponse(data, 'success');
      return 200;
    }

    const err = new Error('API Failed');
    const failed = {
      ...err,
      status: 400,
      errorObj: {
        status: res?.status,
        message: res?.statusText,
      },
    };
    throw failed;
  } catch (e) {
    const error = e;
    if (error.name === 'AbortError') {
      error.status = 408; // failed due to timeout
    } else {
      error.status = 400;
    }
    error.message = 'Post Beacon Failed';
    //error has status key to tell why api got failed
    updateEventResponse(data, 'fail');
    throw error;
  }
};

export default post;
